import { Box } from '@mui/material';
import { styled, type Theme } from '@mui/material/styles';

const proseMirrorBase = (theme: Theme) => ({
  outline: 'none',
  '& p': { marginTop: theme.spacing(0.5), marginBottom: theme.spacing(0.5) },
  '& h2': {
    fontSize: '1.15rem',
    fontWeight: 600,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  '& h3': {
    fontSize: '1.05rem',
    fontWeight: 600,
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.75),
  },
  '& ul, & ol': {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(2.5),
  },
  '& a': { color: theme.palette.primary.main, textDecoration: 'underline' },
  '& s': { textDecoration: 'line-through' },
  '& p.is-editor-empty:first-of-type::before': {
    content: 'attr(data-placeholder)',
    color: theme.palette.text.disabled,
    float: 'left' as const,
    height: 0,
    pointerEvents: 'none' as const,
  },
});

// Editable wrapper: gives the contenteditable a comfortable minimum
// click-target so the empty editor doesn't collapse to a single line.
export const EditorBox = styled(Box)(({ theme }) => ({
  '& .ProseMirror': {
    ...proseMirrorBase(theme),
    minHeight: '6em',
  },
}));

// Read-only wrapper: no minHeight so 1-line legacy notes don't render with
// empty space below them. Caller controls layout (e.g. NoteCardDisplay's
// `-webkit-line-clamp` wrapper).
export const DisplayBox = styled(Box)(({ theme }) => ({
  '& .ProseMirror': proseMirrorBase(theme),
}));
